import { FORTA_BLUE } from '../../../../../../utils/colors';
import { LIST_ROW_BG_COLORS } from '../../../../../common';

export const REFERRAL_FORM_BOX_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  position: 'relative',
  textAlign: 'left',
};

export const UPLOADED_DOCUMENT_ROW_BASE_SX = {
  px: 2,
  py: 1,
  gap: 2,
  cursor: 'pointer',
  '&:focus-visible': { outline: `2px solid ${FORTA_BLUE.primary}`, outlineOffset: -2 },
};

// Shared by every alternating-row list in the referral feature
// (uploaded documents, diagnoses list, assessments list).
export const REFERRAL_LIST_ROW_BG_SX = [
  { bgcolor: LIST_ROW_BG_COLORS[0] },
  { bgcolor: LIST_ROW_BG_COLORS[1] },
];

export const UPLOADED_DOCUMENT_TITLE_SX = {
  color: FORTA_BLUE.dark,
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
